/* eslint-disable no-throw-literal */
import ApiService from 'app/services/ApiService';

export const BOOKMARK_SUCCESS = 'BOOKMARK_SUCCESS';
export const BOOKMARK_BEGIN = 'BOOKMARK_BEGIN';
export const BOOKMARK_FAILURE = 'BOOKMARK_FAILURE';
export const CLEAR_BOOKMARK = 'CLEAR_BOOKMARK';

export const BOOKMARK_PREVIEW_SUCCESS = 'BOOKMARK_PREVIEW_SUCCESS';
export const BOOKMARK_PREVIEW_BEGIN = 'BOOKMARK_PREVIEW_BEGIN';
export const BOOKMARK_PREVIEW_FAILURE = 'BOOKMARK_PREVIEW_FAILURE';
export const CLEAR_BOOKMARK_PREVIEW = 'CLEAR_BOOKMARK_PREVIEW';

export const BOOKMARKCOURSE_FILTERS_SUCCESS = 'BOOKMARKCOURSE_FILTERS_SUCCESS';
export const BOOKMARKCOURSE_FILTERS_BEGIN = 'BOOKMARKCOURSE_FILTERS_BEGIN';
export const BOOKMARKCOURSE_FILTERS_FAILURE = 'BOOKMARKCOURSE_FILTERS_FAILURE';
export const CLEAR_BOOKMARKCOURSE_FILTERS = 'CLEAR_BOOKMARKCOURSE_FILTERS';

export const BOOKMARK_FILTERS_SUCCESS = 'BOOKMARK_FILTERS_SUCCESS';
export const BOOKMARK_FILTERS_BEGIN = 'BOOKMARK_FILTERS_BEGIN';
export const BOOKMARK_FILTERS_FAILURE = 'BOOKMARK_FILTERS_FAILURE';
export const CLEAR_BOOKMARK_FILTERS = 'CLEAR_BOOKMARK_FILTERS';

export const EMPLOYEE_SUPERVISOR_SUCCESS = 'EMPLOYEE_SUPERVISOR_SUCCESS';
export const EMPLOYEE_SUPERVISOR_BEGIN = 'EMPLOYEE_SUPERVISOR_BEGIN';
export const EMPLOYEE_SUPERVISOR_FAILURE = 'EMPLOYEE_SUPERVISOR_FAILURE';
export const CLEAR_EMPLOYEE_SUPERVISOR = 'CLEAR_EMPLOYEE_SUPERVISOR';

export function fetchBookmark(params = {}) {
    return async dispatch => {
        dispatch(bookmarkBegin());
        await ApiService.getBookmarks(params)
            .then(
                result => {
                    dispatch(bookmarkSuccess(result));
                },
                error => {
                    dispatch(bookmarkError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchBookmarkPreview(params = {}) {
    return async dispatch => {
        dispatch(bookmarkPreviewBegin());
        await ApiService.getBookmarkPreview(params)
            .then(
                result => {
                    dispatch(bookmarkPreviewSuccess(result));
                },
                error => {
                    dispatch(bookmarkPreviewError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchBookmarkFilters(params = {}) {
    return async dispatch => {
        dispatch(bookmarkFiltersBegin());
        await ApiService.getBookMarkFilter(params)
            .then(
                result => {
                    dispatch(bookmarkFiltersSuccess(result));
                },
                error => {
                    dispatch(bookmarkFiltersError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}


export function fetchBookmarkCourseFilters(params = {}) {
    return async dispatch => {
        dispatch(bookmarkCourseFiltersBegin());
        await ApiService.getBookmarkCourseFilter(params)
            .then(
                result => {
                    dispatch(bookmarkCourseFiltersSuccess(result));
                },
                error => {
                    dispatch(bookmarkCourseFiltersError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchEmployeeSupervisor() {
    return async dispatch => {
        dispatch(employeeSupervisorBegin());
        await ApiService.getEmployeeSupervisor()
            .then(
                result => {
                    dispatch(employeeSupervisorSuccess(result));
                },
                error => {
                    dispatch(employeeSupervisorError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}



export const bookmarkBegin = () => ({
    type: BOOKMARK_BEGIN,
});
export const bookmarkSuccess = data => ({
    type: BOOKMARK_SUCCESS,
    payload: { data }
})
export const bookmarkError = () => ({
    type: BOOKMARK_FAILURE,
})
export const clearBookmark = () => ({
    type: CLEAR_BOOKMARK,
})

export const bookmarkPreviewBegin = () => ({
    type: BOOKMARK_PREVIEW_BEGIN,
});
export const bookmarkPreviewSuccess = data => ({
    type: BOOKMARK_PREVIEW_SUCCESS,
    payload: { data }
})
export const bookmarkPreviewError = () => ({
    type: BOOKMARK_PREVIEW_FAILURE,
})
export const clearBookmarkPreview = () => ({
    type: CLEAR_BOOKMARK_PREVIEW,
})

export const bookmarkFiltersBegin = () => ({
    type: BOOKMARK_FILTERS_BEGIN,
});
export const bookmarkFiltersSuccess = data => ({
    type: BOOKMARK_FILTERS_SUCCESS,
    payload: { data }
})
export const bookmarkFiltersError = () => ({
    type: BOOKMARK_FILTERS_FAILURE,
})
export const clearBookmarkFilters = () => ({
    type: CLEAR_BOOKMARK_FILTERS,
})

export const bookmarkCourseFiltersBegin = () => ({
    type: BOOKMARKCOURSE_FILTERS_BEGIN,
});
export const bookmarkCourseFiltersSuccess = data => ({
    type: BOOKMARKCOURSE_FILTERS_SUCCESS,
    payload: { data }
})
export const bookmarkCourseFiltersError = () => ({
    type: BOOKMARKCOURSE_FILTERS_FAILURE,
})
export const clearBookmarkCourseFilters = () => ({
    type: CLEAR_BOOKMARKCOURSE_FILTERS,
})

export const employeeSupervisorBegin = () => ({
    type: EMPLOYEE_SUPERVISOR_BEGIN,
});
export const employeeSupervisorSuccess = data => ({
    type: EMPLOYEE_SUPERVISOR_SUCCESS,
    payload: { data }
})
export const employeeSupervisorError = () => ({
    type: EMPLOYEE_SUPERVISOR_FAILURE,
})
export const clearEmployeeSupervisor = () => ({
    type: CLEAR_EMPLOYEE_SUPERVISOR,
})
